<template>
  <v-app-bar elevation="0" color="primary" :height="xs ? '70px' : '104px'">
    <v-container class="pa-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block filter-white"
            :height="xs ? '50px' : '74px'"
          />
        </router-link>

        <div class="d-flex">
          <v-btn
            v-if="!xs"
            class="white--text text-body-1 text-none font-weight-bold px-3 py-5"
            to="/atendimento"
            active-class="nav-link-active"
            tile
            depressed
            text
          >
            ATENDIMENTO
          </v-btn>

          <div class="ml-2">
            <v-btn
              rounded
              depressed
              height="40px"
              min-width="auto"
              width="40px"
              :href="link"
              target="_blank"
              color="white"
              class="ml-2"
              :title="title"
              text
              v-for="({ title, link, icon, size }, keySocial) in social"
              :key="keySocial"
            >
              <v-icon :size="size"> {{ icon }} </v-icon>
            </v-btn>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { getSocial } from "../../config";

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    informations: {},
    social: {},
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest("informations").get({
      save: (state, data) => (this.informations = data),
    });

    this.$rest("pages-informations-medias").get({
      id: this.mod,
      save: (state, data) => (this.social = this.getSocial(data)),
    });
  },
  methods: {
    getSocial,
  },
};
</script>
